const DB_NAME = 'cinemahala_device_db';
const STORE_NAME = 'device_store';
const STORAGE_KEY = 'cmdb_device_token';

function openDatabase() {
  return new Promise((resolve) => {
    if (!window.indexedDB) {
      resolve(null);
      return;
    }
    const request = indexedDB.open(DB_NAME, 1);
    request.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => resolve(null);
  });
}

async function getFromIndexedDB() {
  try {
    const db = await openDatabase();
    if (!db) return null;
    return new Promise((resolve) => {
      const transaction = db.transaction([STORE_NAME], 'readonly');
      const store = transaction.objectStore(STORE_NAME);
      const request = store.get(STORAGE_KEY);
      request.onsuccess = () => resolve(request.result || null);
      request.onerror = () => resolve(null);
    });
  } catch (e) {
    return null;
  }
}

async function setToIndexedDB(value) {
  try {
    const db = await openDatabase();
    if (!db) return;
    const transaction = db.transaction([STORE_NAME], 'readwrite');
    const store = transaction.objectStore(STORE_NAME);
    store.put(value, STORAGE_KEY);
  } catch (e) {
    // Silent fallback
  }
}

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
}

function setCookie(name, value) {
  const maxAge = 60 * 60 * 24 * 730; // 2 years
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; SameSite=Strict`;
}

function generateHardwareHash() {
  const nav = window.navigator;
  const screen = window.screen;
  const components = [
    screen.width,
    screen.height,
    screen.colorDepth,
    nav.language || '',
    Intl.DateTimeFormat().resolvedOptions().timeZone || '',
    nav.hardwareConcurrency || 2
  ];
  const str = components.join('|');
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash) + str.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash).toString(36);
}

export const deviceService = {
  cachedToken: null,

  async getDeviceToken() {
    if (this.cachedToken) return this.cachedToken;

    let token = localStorage.getItem(STORAGE_KEY);
    if (!token) {
      token = getCookie(STORAGE_KEY);
    }
    if (!token) {
      token = await getFromIndexedDB();
    }

    if (!token) {
      const randomUuid = typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : 'dev_' + Math.random().toString(36).substring(2) + Date.now().toString(36);
      const hwHash = generateHardwareHash();
      token = `ch_${hwHash}_${randomUuid}`;
    }

    // Synchronize across all 3 storage mechanisms
    localStorage.setItem(STORAGE_KEY, token);
    setCookie(STORAGE_KEY, token);
    await setToIndexedDB(token);

    this.cachedToken = token;
    return token;
  }
};
